module.exports = __webpack_public_path__ + "img/Inexchange-logo.4bdb5d5a.png";